<template>
   <Card :title="$t('pipelines.label.prospect')" containerClass="mb-5">
    <template #cardToolbar>
      <div style="margin-top: 35px" v-show="pipeline?.status !== 'WON' && pipeline?.status !== 'LOST'">
        <SelectEmoji :color="$getCssVariable('--bs-primary')" :icon="pipeline.feeling" @emoji="addFeeling" :right="$can(abilities.UPDATE_OPPORTUNITIES) || $can(abilities.UPDATE_ALL_OPPORTUNITIES)"/>
      </div>
    </template>
    <div class="row p-4">
      <div class="input-group input-group-solid mb-5" v-if="pipeline?.contact?.lastname"> 
        <span class="input-group-text" id="basic-addon1">
           <i :class="pipeline?.contact?.contactType == 'particular' ? 'fas fa-user icon-orange-circle' : 'fas fa-building icon-yellow-circle'" style="margin-left: -8px; margin-right: 1px"></i>
        </span>
        <input type="text" class="form-control" :value="pipeline?.contact?.fullname" disabled/>
      </div>

      <div  v-if="pipeline?.contact?.customer || pipeline.contact?.supplier" class="input-group input-group-solid mb-2">
          <span class="input-group-text" id="basic-addon2">
            <i class="fas fa-user" style="color: rgba(100, 110, 123, 1);"></i>
          </span>
          <input v-if="pipeline?.contact?.customer && pipeline.contact?.supplier" type="text" class="form-control" :value="$t('contacts.customer') + ' & ' + $t('contacts.supplier')" disabled />
          <input v-else-if="pipeline?.contact?.customer" type="text" class="form-control" :value="$t('contacts.customer')" disabled />
          <input v-else-if="pipeline?.contact?.supplier" type="text" class="form-control" :value="$t('contacts.supplier')" disabled />
      </div>

      <div class="input-group input-group-solid mb-2" v-if="pipeline?.contact?.email">
          <span class="input-group-text" id="basic-addon2">
            <i class="fas fa-envelope" style="color: rgba(100, 110, 123, 1);"></i>
          </span>
          <input type="text" class="form-control" :value="pipeline?.contact?.email" disabled/>
      </div>

      <div class="input-group input-group-solid mb-2" v-if="pipeline?.contact?.phone && pipeline.contact?.phone?.length">
          <span class="input-group-text" id="basic-addon">
            <i class="fas fa-phone-alt" style="color: rgba(100, 110, 123, 1);"></i>
          </span>
          <input type="tel" class="form-control" :value="pipeline?.contact?.phone[0].toString()" disabled/>
      </div>
    </div>
  </Card>

  <Card :title="$t('pipelines.label.intermediator')" v-if="pipeline?.contact?.contactType == 'society' && pipeline?.collaborators?.length > 0" containerClass="mb-5">
    <template #cardToolbar>
      <span :style="{color: secondaryColor, fontSize: '18px', fontWeight: '600'}">{{pipeline?.collaborators?.length}}</span>
    </template>
    <div class="row px-10 py-5">
      <ManyAvatar :size="4" :data="pipeline?.collaborators"/>
    </div>
  </Card>
</template>

<script setup>
import Card from "@/Modules/CRM/components/Card.vue";
import ManyAvatar from "@/components/ManyAvatar.vue"
import {ref} from "vue";
import i18n from "@/plugins/i18n";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import Input from "@/components/Input.vue";
import SelectEmoji from "@/components/SelectEmoji.vue"
import abilities from "@/composables/abilities";

const store = useStore()
const router = useRouter()
const route = useRoute()

const secondaryColor = ref('rgba(240, 120, 23, 1)')

const props = defineProps({pipeline: Object})

function loadPipelineData() {

}

function addFeeling(name){
  store.dispatch('pipelines/addFeeling', {feeling: name, opportunity_id: route.params.id})
  .then(res => {
    loadPipelineData()
  })
  .catch((err) => {

  })
}
</script>

<style scoped>
  .input-group-solid .input-group-text,
  .input-group-solid .form-control {
      border: none;
  }
  .icon-yellow-circle {
    background-color: #F3DC1F;
    border-radius: 50%;
    padding: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: -12px;
    color: #303D4E;
  }
  .icon-orange-circle {
    background-color: #F07817;
    border-radius: 50%;
    padding: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: -12px;
    color: #fff;
  }

</style>
